import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import ModalHistorico from "react-modal";
import ModalBackup from "react-modal";
import ModalVenda from "react-modal";
import ModalCobranca from "react-modal";
import ModalValorVendido from "react-modal";
import { IMaskInput } from "react-imask";
import Paginacao from "../../../componente/paginacao";
import PopUp from "../../../componente/popup";
import PopUpHis from "../../../componente/popup";
import PopUpHisDet from "../../../componente/popup";
import LoadingScreen from "../../../componente/aguarde";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

function CadCliente() {
  const { DateTime } = require("luxon");

  //tela
  const dt = new Date();

  const dt11 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");
  let time =
    dt.getHours().toString().padStart(2, "0") +
    ":" +
    dt.getMinutes().toString().padStart(2, "0");
  let dtcadastro = dt11 + " " + time;

  const AUTOCOMPLETE_URL = "v1/relatorio/filtro";

  const [listaequipe, setlistaequipe] = useState([]);
  const [listaequipe1, setlistaequipe1] = useState([]);
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [ativo, setAtivo] = useState("T");
  const abusca2 = "";

  //abrir form
  const [showform, setshowform] = useState(false);
  const [showformHistorico, setshowformHistorico] = useState(false);
  const [showformBackup, setshowformBackup] = useState(false);
  const [showformVenda, setshowformVenda] = useState(false);
  const [showformHistDet, setshowformHistDet] = useState(false);

  //campos do cadastro de cliente
  const [edtcodcliente, setedtcodcliente] = useState(0);
  const [edtnome, setedtnome] = useState("");
  const [edtcpf, setedtcpf] = useState("");
  const [edtcep, setedtcep] = useState("");
  const [edtendereco, setedtendereco] = useState("");
  const [edtnumero, setedtnumero] = useState("");
  const [edtcomplemento, setedtcomplemento] = useState("");
  const [edtbairro, setedtbairro] = useState("");
  const [edtcidade, setedtcidade] = useState("");
  const [edtuf, setedtuf] = useState("");
  const [edttelefone, setedttelefone] = useState("");
  const [edtwhatsapp, setedtwhatsapp] = useState("");
  const [edtdtcadastro, setedtdtcadastro] = useState("");
  const [edtdtnascimento, setedtdtnascimento] = useState("");
  const [edtativo, setedtativo] = useState("");
  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtobservacao, setedtobservacao] = useState("");

  //Campos temporários
  const [tempcpf, settempcpf] = useState("");
  const [tempendereco, settempendereco] = useState("");
  const [tempnumero, settempnumero] = useState("");
  const [tempcomplemento, settempcomplemento] = useState("");
  const [tempbairro, settempbairro] = useState("");
  const [tempcidade, settempcidade] = useState("");
  const [tempuf, settempuf] = useState("");
  const [temptelefone, settemptelefone] = useState("");
  const [tempwhatsapp, settempwhatsapp] = useState("");

  //campos da venda
  const [edtcodequipe1, setedtcodequipe1] = useState(0);
  const [codvendedor, setcodvendedor] = useState(0);
  const [qtdePeca, setQtdePeca] = useState(0);
  const [qtdeItens, setQtdeItens] = useState(0);
  const [valorPano, setValorPano] = useState(0);
  const [listavendedor, setlistavendedor] = useState([]);
  const [tipo, setTipo] = useState("");
  const [tipoPano, setTipoPano] = useState("");
  const [dtentregapano, setDtEntregaPano] = useState("");
  const [descricaoEquipe, setDescricaoEquipe] = useState("");
  const [nomeVendedor, setNomeVendedor] = useState("");

  //campos do historico
  const [listaHistorico, setListaHistorico] = useState([]);
  const [codContasReceber, setCodContasReceber] = useState(0);

  //campos do backup
  const [listaBackup, setListaBackup] = useState([]);

  //campos Historico Detalhado
  const [listaHistoricoDet, setListaHistoricoDet] = useState([]);

  //Tela Valor da Venda
  const [showformValorVenda, setshowformValorVenda] = useState(false);
  const [edtNome, setEdtNome] = useState("");
  const [edtValorVendido, setEdtValorVendido] = useState(0);
  const [edtPercComissao, setEdtPercComissao] = useState(0);
  const [edtValorEmpresa, setEdtValorEmpresa] = useState(0);
  const [edtValorBrinde, setEdtValorBrinde] = useState(0);
  const [edtCodContasReceber, setEdtCodContasReceber] = useState(0);
  const [edtStatus, setEdtStatus] = useState("");
  const [edtValor, setEdtValor] = useState(0);
  const [edtValorRestante, setEdtValorRestante] = useState(0);
  const [edtCodBanco, setEdtCodBanco] = useState(0);
  const [edtCodMoeda, setEdtCodMoeda] = useState(0);
  const [listaBanco, setListaBanco] = useState([]);
  const [listaMoeda, setListaMoeda] = useState([]);
  const [edtDtPagamento, setEdtDtPagamento] = useState("");
  const [pendencia, setPendencia] = useState(false);
  const [edtCodDetalhe, setedtCodDetalhe] = useState(0);

  const [novo, setnovo] = useState(false);

  const [qtdetotalpag, setqtdetotalpag] = useState(0);
  const [offset, setOffset] = useState(0);

  const [cpfexiste, setcpfexiste] = useState(false);
  const [cpfexiste1, setcpfexiste1] = useState(false);
  const [verificavalor, setverificavalor] = useState(false);
  const [verificadevolucao, setverificadevolucao] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenHist, setIsOpenHist] = useState(false);
  const [isOpenHistDet, setIsOpenHistDet] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");
  const [aTipo, setATipo] = useState("");

  // Adicionar novos estados
  const [inputValue2, setInputValue2] = useState("");
  const [inputValue3, setInputValue3] = useState("");
  const [inputValue4, setInputValue4] = useState("");
  const [listaFiltroEquipe, setListaFiltroEquipe] = useState([]);
  const [listaFiltroCidade, setListaFiltroCidade] = useState([]);
  const [listabairro, setlistabairro] = useState([]);
  const [edtcodequipe2, setedtcodequipe2] = useState(0);
  const [edtbairro2, setedtbairro2] = useState("");
  const [edtcidade2, setedtcidade2] = useState("0");
  const [edtuf2, setedtuf2] = useState("");

  const handleEquipeSelecionado = (equip) => {
    setDescricaoEquipe(equip.descricao);
    setedtcodequipe1(equip.codequipe);
    setlistaequipe1([]);
  };

  const handleEquipeSelecionado2 = (vend) => {
    setNomeVendedor(vend.nome);
    setcodvendedor(vend.codfuncionario);
    setlistavendedor([]);
  };

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setDescricaoEquipe(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaequipe1(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistaequipe1([]);
      setedtcodequipe1(0);
    }
  };

  const handleInputChange2 = async (e) => {
    const value = e.target.value;
    setNomeVendedor(value);

    if (value.length > 0) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/vendedor`, {
          params: { busca: value, codequipe: edtcodequipe1 },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistavendedor(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistavendedor([]);
      setcodvendedor(0);
    }
  };

  const handleOpen = (cad) => {
    setedtcodcliente(cad.codcliente);
    setIsOpen(true);
  };

  const handleOpenHistorico = (cad) => {
    setCodContasReceber(cad.codcontasreceber);
    setIsOpenHist(true);
  };

  const handleConfirma = () => {
    setATipo("cadastro");
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      if (aTipo === "cadastro") {
        ExcluirCad();
        ListarCliente();
      } else if (aTipo === "historico") {
        ExcluirContasReceber();
        ListarHistorico();
      } else {
        ExcluirDetRepasse();
        listaHistoricoDet();
      }

      setIsOpenMotivoExclusao(false);
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleHistConfirma = () => {
    setATipo("historico");
    setIsOpenHist(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleHistClose = () => {
    setIsOpenHist(false);
  };

  function ListarEquipe() {
    api
      .get("v1/cadastro/equipe", {
        params: {
          busca: abusca2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlistaequipe(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarHistorico() {
    api
      .get("v1/cadastro/cliente/historico", {
        params: {
          codequipe: edtcodequipe1,
          codcliente: edtcodcliente,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaHistorico(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarHistorico();
  }, [showformHistorico, descricaoEquipe]);

  function ListarBackup() {
    api
      .get("v1/cadastro/cliente/backupcliente", {
        params: {
          codcliente: edtcodcliente,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaBackup(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarBackup();
  }, [showformBackup]);

  useEffect(() => {
    ListarEquipe();
  }, [showform]);

  async function ListarCliente() {
    setLoading(true);

    try {
      const response = await api.get("v1/cadastro/cliente", {
        params: {
          busca: abusca,
          ativo,
          offset,
          codequipe: edtcodequipe2,
          bairro: edtbairro2,
          cidade: edtcidade2,
          uf: edtuf2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setlista(response.data);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const debounceTimeout = setTimeout(ListarCliente, 500);
    return () => clearTimeout(debounceTimeout);
  }, []);

  function ListarPaginas() {
    api
      .get("cliente/pagtotal", {
        params: {
          busca: abusca,
          ativo,
          codequipe: edtcodequipe2,
          bairro: edtbairro2,
          cidade: edtcidade2,
          uf: edtuf2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setqtdetotalpag(response.data.paginatotal);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarPaginas();
  }, [lista]);

  function VerificarCPF() {
    api
      .get("cliente/verificacpf", {
        params: {
          cpf: edtcpf,
          codequipe: edtcodequipe,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setcpfexiste(response.data.codcliente > 0);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function VerificarCPF1() {
    api
      .get("cliente/verificacpf1", {
        params: {
          cpf: edtcpf,
          codequipe: edtcodequipe,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setcpfexiste1(response.data.codcliente > 0);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function VerificarValor() {
    api
      .get("cliente/verificavalor", {
        params: {
          cpf: edtcpf,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setverificavalor(response.data.codcontasreceber > 0);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function VerificarDevolucao() {
    api
      .get("cliente/verificadevolucao", {
        params: {
          cpf: edtcpf,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setverificadevolucao(response.data.codcontasreceber > 0);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    if (edtcpf.length === 14) {
      const timer = setTimeout(() => {
        VerificarCPF();
        VerificarCPF1();
      }, 1000); // espera 300ms antes de chamar

      return () => clearTimeout(timer);
    }
  }, [edtcpf, edtcodequipe]);

  useEffect(() => {
    if (edtcpf.length === 14) {
      const timer = setTimeout(() => {
        VerificarValor();
        VerificarDevolucao();
      }, 1000); // espera 300ms antes de chamar

      return () => clearTimeout(timer);
    }
  }, [edtcpf]);

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/cliente",
        {
          nome: edtnome,
          cpf: edtcpf,
          cep: edtcep,
          endereco: edtendereco,
          numero: edtnumero,
          complemento: edtcomplemento,
          bairro: edtbairro,
          cidade: edtcidade,
          telefone: edttelefone,
          whatsapp: edtwhatsapp,
          dtcadastro: edtdtcadastro,
          dtnascimento: edtdtnascimento,
          ativo: edtativo,
          codusuario: localStorage.getItem("tempCodUsuario"),
          excluido: "N",
          codempresa: 1,
          codequipe: edtcodequipe,
          uf: edtuf,
          observacao: edtobservacao,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setshowform(false);
        ListarCliente();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function NovaVenda() {
    if (edtcodequipe1 === 0) {
      alert("Informe a Equipe");
    } else if (codvendedor === 0) {
      alert("Informe o vendedor");
    } else if (edtcodcliente === 0) {
      alert("Salve o cadastro primeiro, e depois informe a venda");
    } else {
      api
        .post(
          "v1/cadastro/cliente/novavenda",
          {
            codcliente: edtcodcliente,
            dtentregapano,
            codequipe: edtcodequipe1,
            tipo,
            codvendedor,
            tipopano: tipoPano,
            qtdepeca: qtdePeca,
            qtdeitens: qtdeItens,
            valorpano: valorPano,
            nome: edtnome,
            codusuario: localStorage.getItem("tempCodUsuario"),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
            },
          }
        )
        .then(() => {
          setedtativo('S');
          setshowformVenda(false);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }
  }

  function Editar() {

    if (tempcpf !== edtcpf ||
      tempendereco !== edtendereco ||
      tempnumero !== edtnumero ||
      tempcomplemento !== edtcomplemento ||
      tempbairro !== edtbairro ||
      tempcidade !== edtcidade ||
      temptelefone !== edttelefone ||
      tempwhatsapp !== edtwhatsapp ||
      tempuf !== edtuf) {
      api
        .post(
          "v1/cadastro/clientehistorico",
          {
            codcliente: edtcodcliente,
            cpf: tempcpf,
            endereco: tempendereco,
            numero: tempnumero,
            complemento: tempcomplemento,
            bairro: tempbairro,
            cidade: tempcidade,
            telefone: temptelefone,
            whatsapp: tempwhatsapp,
            uf: tempuf,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
            },
          }
        )
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    api
      .put(
        "v1/cadastro/cliente",
        {
          codcliente: edtcodcliente,
          nome: edtnome,
          cpf: edtcpf,
          cep: edtcep,
          endereco: edtendereco,
          numero: edtnumero,
          complemento: edtcomplemento,
          bairro: edtbairro,
          cidade: edtcidade,
          telefone: edttelefone,
          whatsapp: edtwhatsapp,
          dtcadastro: edtdtcadastro,
          dtnascimento: edtdtnascimento,
          codusuario: localStorage.getItem("tempCodUsuario"),
          ativo: edtativo,
          codequipe: edtcodequipe,
          uf: edtuf,
          observacao: edtobservacao,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setshowform(false);
        ListarCliente();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    if (edtnome === "") {
      alert("Informe o Nome");
    } else if (edtcidade === "") {
      alert("Informe a Cidade");
    } else if (edtcodequipe === 0) {
      alert("Informe a Equipe");
    } else if (cpfexiste && novo) {
      alert("Esse cliente já tem cadastro, verifique!");
    } else {
      novo ? Cadastrar() : Editar();
    }
  }

  function ExcluirCad() {
    api
      .delete("v1/cadastro/cliente", {
        params: {
          codcliente: edtcodcliente,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarCliente();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirContasReceber() {
    api
      .delete("v1/cadastro/cliente/excluirfaturamento", {
        params: {
          codContasReceber,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarHistorico();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function closeModal() {
    setshowform(false);
  }

  function closeModalHistorico() {
    setshowformHistorico(false);
  }

  function closeModalBackup() {
    setshowformBackup(false);
  }

  function closeModalVenda() {
    setshowformVenda(false);
  }

  function closeModalHistoricoDet() {
    setshowformHistDet(false);
  }

  function openModalHistorico() {
    setedtcodequipe1(0);
    setshowformHistorico(true);
  }

  function openModalBackup() {
    setshowformBackup(true);
  }

  function openModalInformarVenda() {
    setshowformVenda(true);

    setDescricaoEquipe("");
    setNomeVendedor("");
    setTipo("R");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let dtcadastro = date;

    setDtEntregaPano(dtcadastro);
    setTipoPano("S");
    setQtdePeca(0);
    setQtdeItens(0);
    setValorPano(0);
  }

  function openModalHistoricoDet(item) {
    api
      .get("/v1/cadastro/cliente/historicodet", {
        params: {
          codcontasreceber: item.codcontasreceber,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaHistoricoDet(response.data);
        setshowformHistDet(true);
        setCodContasReceber(item.codcontasreceber);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodcliente(0);
    setedtnome("");
    setedtcpf("");
    setedtcep("");
    setedtendereco("");
    setedtnumero("");
    setedtcomplemento("");
    setedtbairro("");
    setedtcidade("");
    setedtuf("");
    setedttelefone("");
    setedtwhatsapp("");
    setedtcodequipe(0);
    setedtobservacao("");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0");
    let dtcadastro = date + "T" + time;

    setedtdtcadastro(dtcadastro);
    setedtdtnascimento("");
    setedtativo("S");
  }

  function openModalEditar(props) {
    api
      .get("/v1/cadastro/cliente/clienteum", {
        params: {
          codcliente: props.codcliente,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setshowform(true);
        setnovo(false);

        setedtcodcliente(props.codcliente);

        setedtnome(response.data.nome);

        setedtcpf(response.data.cpf);
        settempcpf(response.data.cpf);

        setedtcep(response.data.cep);

        setedtendereco(response.data.endereco);
        settempendereco(response.data.endereco);

        setedtnumero(response.data.numero);
        settempnumero(response.data.numero);

        setedtcomplemento(response.data.complemento);
        settempcomplemento(response.data.complemento);

        setedtbairro(response.data.bairro);
        settempbairro(response.data.bairro);

        setedtcidade(response.data.cidade);
        settempcidade(response.data.cidade);

        setedtuf(response.data.uf);
        settempuf(response.data.uf);

        setedttelefone(response.data.telefone);
        settemptelefone(response.data.telefone);

        setedtwhatsapp(response.data.whatsapp);
        settempwhatsapp(response.data.whatsapp);

        setedtcodequipe(response.data.codequipe);

        setedtobservacao(response.data.observacao);

        const dt = new Date(response.data.dtcadastro);
        const date =
          dt.getFullYear() +
          "-" +
          (dt.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          dt.getDate().toString().padStart(2, "0");
        let time =
          dt.getHours().toString().padStart(2, "0") +
          ":" +
          dt.getMinutes().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        setedtdtcadastro(dtcadastro);

        if (response.data.dtnascimento == null) {
          setedtdtnascimento("");
        } else {
          const dt1 = DateTime.fromISO(response.data.dtnascimento)
            .plus({ hours: 3 })
            .toFormat("yyyy-MM-dd");

          setedtdtnascimento(dt1);
        }
        setedtativo(response.data.ativo);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  function Recebimento() {
    api
      .post(
        "v1/operacoes/repasse",
        {
          coddetalhe: edtCodDetalhe,
          codcontasreceber: edtCodContasReceber,
          dtlancamento: dtcadastro,
          dtbaixa: edtDtPagamento,
          valorvendido: edtValorVendido,
          perccomissao: edtPercComissao,
          valorempresa: edtValorEmpresa,
          valorbrinde: edtValorBrinde,
          valor: edtValor,
          valorrestante: edtValorRestante,
          codbanco: edtCodBanco,
          codmoeda: edtCodMoeda,
          status: edtStatus,
          excluido: "N",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setshowformValorVenda(false);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function InformarRecebimento() {
    if (edtCodContasReceber === 0) {
      alert("Volte e selecione o repasse");
    } else if (edtStatus === "P") {
      if (pendencia === false) {
        if (edtValorEmpresa === 0) {
          alert("Informe o Valor da Empresa");
        } else if (edtValor === 0) {
          alert("Informe o valor");
        } else if (edtCodBanco === 0) {
          alert("Informe o Caixa/Banco");
        } else if (edtCodMoeda === 0) {
          alert("Informe a Condição de Pagamento");
        } else if (edtDtPagamento === "") {
          alert("Informe a Data de Pagamento");
        } else {
          Recebimento();
        }
      } else {
        if (edtCodBanco === 0) {
          alert("Informe o Caixa/Banco");
        } else if (edtValor === 0) {
          alert("Informe o valor");
        } else if (edtCodMoeda === 0) {
          alert("Informe a Condição de Pagamento");
        } else if (edtDtPagamento === "") {
          alert("Informe a Data de Pagamento");
        } else {
          Recebimento();
        }
      }
    } else if (edtStatus === "A") {
      if (edtValorEmpresa === 0) {
        alert("Informe o Valor da Empresa");
      } else {
        Recebimento();
      }
    } else if (edtStatus === "N") {
      if (edtValorEmpresa === 0) {
        alert("Informe o Valor da Empresa");
      } else {
        Recebimento();
      }
    } else if (edtStatus === "D") {
      if (edtValorEmpresa > 0) {
        alert("Não é para informar o valor");
      } else {
        Recebimento();
      }
    } else {
      Recebimento();
    }
  }

  function openModalEditarDet(item) {
    api
      .get("/v1/operacoes/repasseum1", {
        params: {
          coddetalhe: item.coddetalhe,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setshowformValorVenda(true);
        setEdtNome(response.data.nome);
        setEdtValorVendido(response.data.valorvendido);
        setEdtPercComissao(response.data.perccomissao);
        setEdtValorEmpresa(response.data.valorempresa);
        setEdtCodContasReceber(response.data.codcontasreceber);
        setEdtStatus(response.data.status);
        setEdtValorRestante(0);
        setEdtCodBanco(response.data.codbanco);
        setEdtCodMoeda(response.data.codmoeda);

        if (response.data.dtbaixa == null) {
          setEdtDtPagamento("");
        } else {
          const dt = new Date(response.data.dtbaixa);
          const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
          let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0");
          let dtcadastro = date + "T" + time;

          setEdtDtPagamento(dtcadastro);
        }

        setPendencia(false);
        setEdtValor(response.data.valor);
        setedtCodDetalhe(response.data.coddetalhe);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function closeModalDet() {
    setshowformValorVenda(false);
  }

  function ListarMoeda() {
    api
      .get("v1/cadastro/moeda", {
        params: {
          busca: "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaMoeda(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarMoeda();
  }, [showformValorVenda]);

  function ListarBanco() {
    api
      .get("v1/cadastro/banco", {
        params: {
          busca: "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaBanco(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarBanco();
  }, [showformValorVenda]);

  const handleOpenHistoricoDet = (cad) => {
    setedtCodDetalhe(cad.coddetalhe);
    setIsOpenHistDet(true);
  };

  const handleHistDetClose = () => {
    setIsOpenHistDet(false);
  };

  const handleHistDetConfirma = () => {
    setATipo("detalhe");
    setIsOpenHistDet(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  function ExcluirDetRepasse() {
    api
      .delete("v1/operacoes/excluirdetrepasse", {
        params: {
          coddetalhe: edtCodDetalhe,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        listaHistoricoDet();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  const handleEquipeSelecionadoFiltro = (equip) => {
    setInputValue2(equip.descricao);
    setedtcodequipe2(equip.codequipe);
    setOffset(0);
    setListaFiltroEquipe([]);
  };

  const handleInputChangeBairro = async (e) => {
    const value = e.target.value;
    setInputValue4(value);

    if (value.length > 2) {
      const timeoutId = setTimeout(async () => {
        setLoading(true);
        try {
          const response = await api.get(`${AUTOCOMPLETE_URL}/bairro`, {
            params: { busca: value, cidade: edtcidade2, uf: edtuf2 },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
            },
          });
          setlistabairro(response.data);
        } catch (error) {
          console.log("ops! ocorreu um erro: " + error);
        } finally {
          setLoading(false);
        }
      }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

      // Cleanup function para limpar o timeout anterior
      return () => clearTimeout(timeoutId);
    } else {
      setlistabairro([]);
      setedtbairro2("");
    }
  };

  const handleCidadeSelecionado = (cid) => {
    setInputValue3(cid.cidade + " - " + cid.uf);
    setedtcidade2(cid.cidade);
    setedtuf2(cid.uf);
    setOffset(0);
    setListaFiltroCidade([]);
  };

  const handleInputChangeEquipe = (e) => {
    const value = e.target.value;
    setInputValue2(value);

    if (value.length > 2) {
      const timeoutId = setTimeout(async () => {
        setLoading(true);
        try {
          const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
            params: { busca: value },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
            },
          });
          setListaFiltroEquipe(response.data);
          setLoading(false);
        } catch (error) {
          console.log("ops! ocorreu um erro: " + error);
        } finally {
          setLoading(false);
        }
      }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

      // Cleanup function para limpar o timeout anterior
      return () => clearTimeout(timeoutId);
    } else {
      setListaFiltroEquipe([]);
      setedtcodequipe2(0);
    }
  };

  const handleBairroSelecionado = (bai) => {
    setInputValue4(bai);
    setedtbairro2(bai);
    setOffset(0);
    setlistabairro([]);
  };

  const handleInputChangeCidade = async (e) => {
    const value = e.target.value;
    setInputValue3(value);

    if (value.length > 2) {
      const timeoutId = setTimeout(async () => {
        setLoading(true);
        try {
          const response = await api.get(`${AUTOCOMPLETE_URL}/cidade`, {
            params: { busca: value },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
            },
          });
          setListaFiltroCidade(response.data);
        } catch (error) {
          console.log("ops! ocorreu um erro: " + error);
        } finally {
          setLoading(false);
        }
      }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

      // Cleanup function para limpar o timeout anterior
      return () => clearTimeout(timeoutId);
    } else {
      setListaFiltroCidade([]);
      setedtcidade2("0");
      setedtuf2("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      ListarCliente(); // Chama a função ao pressionar Enter
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
          <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>

            <PopUpHis isOpen={isOpenHist} onClose={handleHistClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleHistConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleHistClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUpHis>

            <PopUpHisDet isOpen={isOpenHistDet} onClose={handleHistDetClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleHistDetConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleHistDetClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUpHisDet>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
            contentLabel="Modal 2"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
              </div>

              <div className="modal-body">
                <form>
                  <div className="row">
                    <div className="col-sm-8">
                      <label htmlFor="nome" className="form-label">
                        Nome
                      </label>
                      <input
                        type="text"
                        id="nome"
                        className="form-control"
                        placeholder="Nome"
                        value={edtnome}
                        onChange={(e) => setedtnome(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="cpf" className="form-label">
                        CPF
                      </label>
                      <IMaskInput
                        mask={"000.000.000-00"}
                        radix="."
                        id="cpf"
                        className="form-control"
                        placeholder="CPF"
                        value={edtcpf}
                        onAccept={(value) => setedtcpf(value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="cep" className="form-label">
                        CEP
                      </label>
                      <IMaskInput
                        mask={"00000-000"}
                        radix="."
                        id="cep"
                        className="form-control"
                        placeholder="CEP"
                        value={edtcep}
                        onAccept={(value) => setedtcep(value)}
                      />
                    </div>

                    <div className="col-sm-6">
                      <label htmlFor="endereco" className="form-label">
                        Endereço
                      </label>
                      <input
                        type="text"
                        id="endereco"
                        className="form-control"
                        placeholder="Endereço"
                        value={edtendereco}
                        onChange={(e) => setedtendereco(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="numero" className="form-label">
                        Número
                      </label>
                      <input
                        type="text"
                        id="numero"
                        className="form-control"
                        placeholder="Número"
                        value={edtnumero}
                        onChange={(e) => setedtnumero(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="complemento" className="form-label">
                        Complemento
                      </label>
                      <input
                        type="text"
                        id="complemento"
                        className="form-control"
                        placeholder="Complemento"
                        value={edtcomplemento}
                        onChange={(e) => setedtcomplemento(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="bairro" className="form-label">
                        Bairro
                      </label>
                      <input
                        type="text"
                        id="bairro"
                        className="form-control"
                        placeholder="Bairro"
                        value={edtbairro}
                        onChange={(e) => setedtbairro(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="cidade" className="form-label">
                        Cidade
                      </label>
                      <input
                        type="text"
                        id="cidade"
                        className="form-control"
                        placeholder="Cidade"
                        value={edtcidade}
                        onChange={(e) => setedtcidade(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-1">
                      <label htmlFor="UF" className="form-label">
                        UF
                      </label>
                      <input
                        type="text"
                        id="UF"
                        className="form-control"
                        placeholder="UF"
                        value={edtuf}
                        onChange={(e) => setedtuf(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="telefone" className="form-label">
                        Telefone
                      </label>
                      <IMaskInput
                        mask="(00) 0 0000-0000"
                        radix="."
                        id="telefone"
                        className="form-control"
                        placeholder="Telefone"
                        value={edttelefone}
                        onAccept={(value) => setedttelefone(value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="whatsapp" className="form-label">
                        WhatsApp
                      </label>
                      <IMaskInput
                        mask="(00) 0 0000-0000"
                        id="whatsapp"
                        className="form-control"
                        placeholder="WhatsApp"
                        value={edtwhatsapp}
                        onAccept={(value) => setedtwhatsapp(value)}
                      />
                    </div>

                    <div className="col-sm-6">
                      <label htmlFor="equipe" className="form-label">
                        Equipe
                      </label>
                      <select
                        id="equipe"
                        className="form-select"
                        value={edtcodequipe}
                        onChange={(e) => setedtcodequipe(e.target.value)}
                      >
                        <option value="0">Escolha a equipe</option>
                        {listaequipe.map(function (equipe) {
                          return (
                            <option
                              key={equipe.codequipe}
                              value={equipe.codequipe}
                            >
                              {equipe.descricao}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="dtcadastro" className="form-label">
                        Dt. Cadastro
                      </label>
                      <input
                        type="datetime-local"
                        id="dtcadastro"
                        className="form-control"
                        placeholder="dtcadastro"
                        value={edtdtcadastro}
                        onChange={(e) => setedtdtcadastro(e.target.value)}
                        disabled
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="dtnascimento" className="form-label">
                        Dt. Nascimento
                      </label>
                      <input
                        type="date"
                        id="dtnascimento"
                        className="form-control"
                        placeholder="dtnascimento"
                        value={edtdtnascimento}
                        onChange={(e) => setedtdtnascimento(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <div>
                        <label className="form-label">Ativo</label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label className="form-check-label">Sim</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <label htmlFor="observacao" className="form-label">
                        Observação
                      </label>
                      <textarea
                        rows={3}
                        wrap="true"
                        id="observacao"
                        className="form-control"
                        placeholder="Observação"
                        value={edtobservacao}
                        onChange={(e) => setedtobservacao(e.target.value)}
                      />
                    </div>
                  </div>

                  {cpfexiste ? (
                    <div className="alert alert-danger mt-2" role="alert">
                      Esse cliente já tem cadastro nessa equipe
                    </div>
                  ) : null}

                  {cpfexiste1 ? (
                    <div className="alert alert-danger mt-2" role="alert">
                      Esse cliente já tem cadastro em outra equipe
                    </div>
                  ) : null}

                  {verificavalor ? (
                    <div className="alert alert-danger mt-2" role="alert">
                      Esse cliente tem lançamento de valores inferior a R$ 100,00
                    </div>
                  ) : null}

                  {verificadevolucao ? (
                    <div className="alert alert-danger mt-2" role="alert">
                      Esse cliente tem devolução no seu histórico
                    </div>
                  ) : null}
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-6 d-flex justify-content-start">
                  <button
                    className="btn btn-primary"
                    onClick={openModalInformarVenda}
                  >
                    Informar Venda
                  </button>
                  <button
                    className="btn btn-primary ms-4"
                    onClick={openModalHistorico}
                  >
                    Histórico
                  </button>
                  <button
                    className="btn btn-primary ms-4"
                    onClick={openModalBackup}
                  >
                    Backup Dados
                  </button>
                </div>

                <div className="col-5 d-flex justify-content-end">
                  <button className="btn btn-danger ms-4" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button className="btn btn-success ms-4" onClick={Salvar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          <ModalVenda
            isOpen={showformVenda}
            onRequestClose={closeModalVenda}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
            contentLabel="Modal 1"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                <h2>Nova Venda de: {edtnome}</h2>
              </div>

              <div className="modal-body">
                <form>
                  <div className="row">
                    <div className="col-xl-3 col-lg-5 col-md-5 col-sm-5">
                      <label htmlFor="equipe" className="form-label">
                        Equipe
                      </label>
                      <input
                        id="equipe"
                        type="text"
                        className="form-control"
                        value={descricaoEquipe}
                        onChange={handleInputChange}
                      />
                      <ul className="autocomplete-list">
                        {listaequipe1.map((equipe) => (
                          <li
                            key={equipe.codequipe}
                            onClick={() => handleEquipeSelecionado(equipe)}
                          >
                            {equipe.descricao}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="col-sm-4">
                      <div>
                        <label className="form-label">Tipo</label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipo"
                            value="R"
                            onChange={(e) => setTipo(e.target.value)}
                            checked={tipo === "R"}
                          />
                          <label className="form-check-label">Reposição</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipo"
                            value="N"
                            onChange={(e) => setTipo(e.target.value)}
                            checked={tipo === "N"}
                          />
                          <label className="form-check-label">
                            Cliente Novo
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-3 col-lg-5 col-md-5 col-sm-5">
                      <label htmlFor="vendedor" className="form-label">
                        Vendedor
                      </label>
                      <input
                        id="vendedor"
                        type="text"
                        className="form-control"
                        value={nomeVendedor}
                        onChange={handleInputChange2}
                      />
                      <ul className="autocomplete-list">
                        {listavendedor.map((vend) => (
                          <li
                            key={vend.codfuncionario}
                            onClick={() => handleEquipeSelecionado2(vend)}
                          >
                            {vend.nome}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="dtentregapano" className="form-label">
                        Dt. Entrega do Pano
                      </label>
                      <input
                        type="date"
                        id="dtentregapano"
                        className="form-control"
                        placeholder="dtentregapano"
                        value={dtentregapano}
                        onChange={(e) => setDtEntregaPano(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <label className="form-label">Tipo de Pano</label>
                      <br />
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipopano"
                          value="S"
                          onChange={(e) => setTipoPano(e.target.value)}
                          checked={tipoPano === "S"}
                        />
                        <label className="form-check-label">Simples</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipopano"
                          value="E"
                          onChange={(e) => setTipoPano(e.target.value)}
                          checked={tipoPano === "E"}
                        />
                        <label className="form-check-label">Especial</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipopano"
                          value="O"
                          onChange={(e) => setTipoPano(e.target.value)}
                          checked={tipoPano === "O"}
                        />
                        <label className="form-check-label">Ouro</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipopano"
                          value="P"
                          onChange={(e) => setTipoPano(e.target.value)}
                          checked={tipoPano === "P"}
                        />
                        <label className="form-check-label">Prata</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipopano"
                          value="B"
                          onChange={(e) => setTipoPano(e.target.value)}
                          checked={tipoPano === "B"}
                        />
                        <label className="form-check-label">Bronze</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipopano"
                          value="M"
                          onChange={(e) => setTipoPano(e.target.value)}
                          checked={tipoPano === "M"}
                        />
                        <label className="form-check-label">Maleta</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipopano"
                          value="L"
                          onChange={(e) => setTipoPano(e.target.value)}
                          checked={tipoPano === "L"}
                        />
                        <label className="form-check-label">Platinado</label>
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="qtdepeca" className="form-label">
                        Qtde Peças
                      </label>
                      <input
                        type="number"
                        id="qtdepeca"
                        className="form-control"
                        value={qtdePeca}
                        onChange={(e) => setQtdePeca(e.target.valueAsNumber)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="qtdeitens" className="form-label">
                        Qtde Itens
                      </label>
                      <input
                        type="number"
                        id="qtdeitens"
                        className="form-control"
                        value={qtdeItens}
                        onChange={(e) => setQtdeItens(e.target.valueAsNumber)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="valorpano" className="form-label">
                        Valor do Pano
                      </label>
                      <input
                        type="number"
                        id="valorpano"
                        className="form-control"
                        value={valorPano}
                        onChange={(e) => setValorPano(e.target.valueAsNumber)}
                      />
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-danger ms-4"
                    onClick={closeModalVenda}
                  >
                    Fechar
                  </button>
                  <button className="btn btn-success ms-4" onClick={NovaVenda}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </ModalVenda>

          <ModalHistorico
            isOpen={showformHistorico}
            onRequestClose={closeModalHistorico}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
            contentLabel="Modal 1"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                <h2>Histórico Financeiro da Cliente: {edtnome}</h2>
              </div>

              <div className="modal-body">
                <form>
                  <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5">
                    <label htmlFor="equipe" className="form-label">
                      Equipe
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={descricaoEquipe}
                      onChange={handleInputChange}
                    />
                    <ul className="autocomplete-list">
                      {listaequipe1.map((equipe) => (
                        <li
                          key={equipe.codequipe}
                          onClick={() => handleEquipeSelecionado(equipe)}
                        >
                          {equipe.descricao}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="row mt-3">
                    <hr />
                  </div>

                  <div className="row tabela">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Código</th>
                          <th>Entrega</th>
                          <th>Vencimento</th>
                          <th>Tipo Pano</th>
                          <th>Qtde Peças</th>
                          <th>Qtde Itens</th>
                          <th>Valor Pano</th>
                          <th>Valor Empresa</th>
                          <th>Status</th>
                          <th>Vendedor</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaHistorico.map(function (item) {
                          return (
                            <tr key={item.codcontasreceber}>
                              <th>{item.codcontasreceber}</th>
                              <th>{FormataData(item.dtentragapano)}</th>
                              <th>{FormataData(item.dtvencimento)}</th>
                              <th>{item.tipopano}</th>
                              <th>{item.qtdepeca}</th>
                              <th>{item.qtdeitens}</th>
                              <th>
                                {parseFloat(item.valorpano).toLocaleString(
                                  "pt-BR",
                                  { style: "currency", currency: "BRL" }
                                )}
                              </th>
                              <th>
                                {parseFloat(item.valorempresa).toLocaleString(
                                  "pt-BR",
                                  { style: "currency", currency: "BRL" }
                                )}
                              </th>
                              <th
                                style={{
                                  color:
                                    item.status === "PAGO" ? "green" : "red",
                                }}
                              >
                                {item.status}
                              </th>
                              <th>{item.vendedor}</th>
                              <th>
                                <div className="d-flex justify-content-center">
                                  <button
                                    className="btn fa-solid fa-list"
                                    type="button"
                                    onClick={() => openModalHistoricoDet(item)}
                                  ></button>
                                  <button
                                    className="btn fa-solid fa-trash"
                                    type="button"
                                    onClick={() => handleOpenHistorico(item)}
                                  ></button>
                                </div>
                              </th>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan={5}>
                            Quantidade de Registros: {listaHistorico.length}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-danger ms-4"
                    onClick={closeModalHistorico}
                  >
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </ModalHistorico>

          <ModalBackup
            isOpen={showformBackup}
            onRequestClose={closeModalBackup}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
            contentLabel="Modal 1"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                <h2>Backup dos Dados do Cliente: {edtnome}</h2>
              </div>

              <div className="modal-body">
                <form>
                  <div className="row tabela">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Dt. Cadastro</th>
                          <th>CPF</th>
                          <th>Endereço</th>
                          <th>Número</th>
                          <th>Complemento</th>
                          <th>Bairro</th>
                          <th>Cidade</th>
                          <th>UF</th>
                          <th>Telefone</th>
                          <th>WhatsApp</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaBackup.map(function (item) {
                          return (
                            <tr key={item.codhistorico}>
                              <th>{FormataData(item.dtcadastro)}</th>
                              <th>{item.cpf}</th>
                              <th>{item.endereco}</th>
                              <th>{item.numero}</th>
                              <th>{item.complemento}</th>
                              <th>{item.bairro}</th>
                              <th>{item.cidade}</th>
                              <th>{item.uf}</th>
                              <th>{item.telefone}</th>
                              <th>{item.whatsapp}</th>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan={5}>
                            Quantidade de Registros: {listaBackup.length}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-danger ms-4"
                    onClick={closeModalBackup}
                  >
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </ModalBackup>

          <ModalCobranca
            isOpen={showformHistDet}
            onRequestClose={closeModalHistoricoDet}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
            contentLabel="Modal 1"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                <h2>
                  Histórico Detalhado do Cliente: {edtnome} - Título:{" "}
                  {codContasReceber}
                </h2>
              </div>

              <div className="modal-body tabela">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Lançamento</th>
                      <th>Baixa</th>
                      <th>Valor</th>
                      <th>Banco</th>
                      <th>Moeda</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaHistoricoDet.map(function (item) {
                      return (
                        <tr key={item.coddetalhe}>
                          <th>{item.coddetalhe}</th>
                          <th>{FormataData(item.dtlancamento)}</th>
                          <th>{FormataData(item.dtbaixa)}</th>
                          <th>
                            {parseFloat(item.valor).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </th>
                          <th>{item.banco}</th>
                          <th>{item.moeda}</th>
                          <th>{item.status}</th>
                          <th>
                            <div className="d-flex justify-content-center">
                              <button
                                className="btn fa-regular fa-pen-to-square"
                                onClick={() => openModalEditarDet(item)}
                              ></button>
                              <button
                                className="btn fa-solid fa-trash"
                                type="button"
                                onClick={() => handleOpenHistoricoDet(item)}
                              ></button>
                            </div>
                          </th>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colSpan={5}>
                        Quantidade de Registros: {listaHistoricoDet.length}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-danger ms-4"
                    onClick={closeModalHistoricoDet}
                  >
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </ModalCobranca>

          <ModalValorVendido
            isOpen={showformValorVenda}
            onRequestClose={closeModalDet}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="modal-header">
              <h2>Informe o Valor da Venda de: {edtNome}</h2>
            </div>

            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                    <label htmlFor="valorvendido" className="form-label">
                      Valor Vendido
                    </label>
                    <input
                      type="number"
                      id="valorvendido"
                      className="form-control"
                      value={edtValorVendido}
                      onChange={(e) => {
                        setEdtValorVendido(e.target.valueAsNumber);
                        setEdtValorEmpresa(e.target.valueAsNumber);
                      }}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                    <label htmlFor="comissao" className="form-label">
                      Perc. Comissão
                    </label>
                    <input
                      type="number"
                      id="comissao"
                      className="form-control"
                      value={edtPercComissao}
                      onChange={(e) => {
                        const newPercComissao = e.target.value;
                        setEdtPercComissao(newPercComissao);
                        setEdtValorEmpresa(
                          Math.round(
                            edtValorVendido -
                            edtValorVendido * (newPercComissao / 100)
                          )
                        );
                        setEdtValor(
                          Math.round(
                            edtValorVendido -
                            edtValorVendido * (newPercComissao / 100)
                          )
                        );
                      }}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                    <label htmlFor="valorempresa" className="form-label">
                      Valor Empresa
                    </label>
                    <input
                      type="number"
                      id="valorempresa"
                      className="form-control"
                      value={edtValorEmpresa}
                      onChange={(e) =>
                        setEdtValorEmpresa(e.target.valueAsNumber)
                      }
                      disabled
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                    <label htmlFor="valorbrinde" className="form-label">
                      Valor Brinde
                    </label>
                    <input
                      type="number"
                      id="valorbrinde"
                      className="form-control"
                      value={edtValorBrinde}
                      onChange={(e) => {
                        setEdtValorBrinde(e.target.valueAsNumber);
                      }}
                    />
                  </div>
                </div>

                <div className="row">
                  <p />
                  <hr />
                </div>

                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div>
                      <label className="form-label">Status</label>
                      <br />
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          value="P"
                          onChange={(e) => setEdtStatus(e.target.value)}
                          checked={edtStatus === "P"}
                        />
                        <label className="form-check-label">Pago</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="ativo"
                          value="A"
                          onChange={(e) => setEdtStatus(e.target.value)}
                          checked={edtStatus === "A"}
                        />
                        <label className="form-check-label">Aberto</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="ativo"
                          value="N"
                          onChange={(e) => setEdtStatus(e.target.value)}
                          checked={edtStatus === "N"}
                        />
                        <label className="form-check-label">Não Visto</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="ativo"
                          value="D"
                          onChange={(e) => setEdtStatus(e.target.value)}
                          checked={edtStatus === "D"}
                        />
                        <label className="form-check-label">Devolvido</label>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12">
                    <label htmlFor="valor" className="form-label">
                      Valor
                    </label>
                    <input
                      type="number"
                      id="valor"
                      className="form-control"
                      value={edtValor}
                      onChange={(e) => {
                        const newValorRestante = e.target.valueAsNumber;
                        setEdtValor(newValorRestante);
                        setEdtValorRestante(edtValorEmpresa - newValorRestante);
                      }}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12">
                    <label htmlFor="valorrestante" className="form-label">
                      Valor Restante
                    </label>
                    <input
                      type="number"
                      id="valorrestante"
                      className="form-control"
                      value={edtValorRestante}
                      disabled
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <label htmlFor="banco" className="form-label">
                      Localize o Banco/Caixa
                    </label>
                    <select
                      id="banco"
                      className="form-select"
                      value={edtCodBanco}
                      onChange={(e) => setEdtCodBanco(e.target.value)}
                      disabled={edtStatus !== "P"}
                    >
                      <option value="0">Escolha o banco/caixa</option>
                      {listaBanco.map(function (ban) {
                        return (
                          <option key={ban.codbanco} value={ban.codbanco}>
                            {ban.banco}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <label htmlFor="moeda" className="form-label">
                      Localize a Condição de Pagamento
                    </label>
                    <select
                      id="moeda"
                      className="form-select"
                      value={edtCodMoeda}
                      onChange={(e) => setEdtCodMoeda(e.target.value)}
                      disabled={edtStatus !== "P"}
                    >
                      <option value="0">Escolha a condição de pagamento</option>
                      {listaMoeda.map(function (moe) {
                        return (
                          <option key={moe.codmoeda} value={moe.codmoeda}>
                            {moe.moeda}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                    <label htmlFor="dtpagamento" className="form-label">
                      Dt. Pagamento
                    </label>
                    <input
                      type="datetime-local"
                      id="dtpagamento"
                      className="form-control"
                      placeholder="dtcadastro"
                      value={edtDtPagamento}
                      onChange={(e) => setEdtDtPagamento(e.target.value)}
                      disabled={edtStatus !== "P"}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button className="btn btn-danger ms-4" onClick={closeModalDet}>
                  Fechar
                </button>
                <button
                  className="btn btn-success ms-4"
                  onClick={InformarRecebimento}
                >
                  Salvar
                </button>
              </div>
            </div>
          </ModalValorVendido>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Cliente</h1>
          <p className="ms-4">
            Rotina para cadastrar todos os clientes da empresa.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-xl-8 col-lg-6 col-md-6 col-sm-12">
            <label htmlFor="busca" className="form-label">
              Busca
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por: Código, nome ou cpf"
                name="busca"
                id="busca"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                value={abusca}
                onChange={(e) => {
                  setabusca(e.target.value);
                  setOffset(0);
                }}
                onKeyDown={handleKeyDown}
              />
              <button className="btn btn-outline-secondary fa-solid fa-magnifying-glass" type="button" id="button-addon2" onClick={() => ListarCliente()}></button>
              {loading && <LoadingScreen />}
            </div>
          </div>

          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12">
            <label className="form-label">Ativo</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="ativo"
                value="T"
                onChange={(e) => setAtivo(e.target.value)}
                checked={ativo === "T"}
              />
              <label className="form-check-label">Todos</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="ativo"
                value="S"
                onChange={(e) => setAtivo(e.target.value)}
                checked={ativo === "S"}
              />
              <label className="form-check-label">Ativo</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="ativo"
                value="N"
                onChange={(e) => setAtivo(e.target.value)}
                checked={ativo === "N"}
              />
              <label className="form-check-label">Inativo</label>
            </div>
          </div>

          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/cliente")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row">
          {/* Adicionar os novos campos de filtro */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <label htmlFor="equipe" className="form-label">
              Equipe
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue2}
              onChange={handleInputChangeEquipe}
            />
            <ul className="autocomplete-list">
              {listaFiltroEquipe.map((equipe) => (
                <li
                  key={equipe.codequipe}
                  onClick={() => handleEquipeSelecionadoFiltro(equipe)}
                >
                  {equipe.descricao}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <label htmlFor="cidade" className="form-label">
              Cidade
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue3}
              onChange={handleInputChangeCidade}
            />
            <ul className="autocomplete-list">
              {listaFiltroCidade.map((cid) => (
                <li
                  key={cid.cidade}
                  onClick={() => handleCidadeSelecionado(cid)}
                >
                  {cid.cidade} - {cid.uf}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <label htmlFor="bairro" className="form-label">
              Bairro
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue4}
              onChange={handleInputChangeBairro}
            />
            <ul className="autocomplete-list">
              {listabairro.map((bai, index) => (
                <li
                  key={index}
                  onClick={() => handleBairroSelecionado(bai)}
                >
                  {bai}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Nome</th>
                <th className="equipe">Equipe</th>
                <th className="cpf">CPF</th>
                <th className="whatsapp">WhatsApp</th>
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codcliente}>
                    <th>{item.codcliente}</th>
                    <th>{item.nome}</th>
                    <th>{item.equipe}</th>
                    <th>{item.cpf}</th>
                    <th>{item.whatsapp}</th>
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/cliente")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/cliente")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
          <div className="row">
            <Paginacao
              limit={20}
              total={qtdetotalpag}
              offset={offset}
              setOffset={setOffset}
            />
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>
      </div>
    </>
  );
}

export default CadCliente;
